import { Component, OnInit, Input } from '@angular/core';
import { BookingOrderService } from '../../services/booking-order.service';
import { OrderLine } from '../../../order/models/order-line';
import { BookingStepService } from '../../services/booking-step.service';
import { AreaItem } from '../../models/area-item';

@Component({
  selector: 'app-booking-product-configuration-page',
  templateUrl: './booking-product-configuration-page.component.html',
  styleUrls: ['./booking-product-configuration-page.component.css']
})
export class BookingProductConfigurationPageComponent implements OnInit {

  private _errorMessage = 'Please fill out the form!';
  quantity: number[];
  orderLines: OrderLine[];
  startPersonsNumbering = 0;
  private _areaItems: AreaItem[];
  private _isValidForwardButton = false;
  private _orderLinePartnerFormValidByIndex = Array<boolean>();

  constructor(
    private bookingOrderService: BookingOrderService,
    private bookingStepService: BookingStepService,
  ) { }

  ngOnInit(): void {
    this._areaItems = this.bookingOrderService.areaItems;
    const order = this.bookingOrderService.order;
    if (order && order.orderLines) {
      this.orderLines = order.orderLines;
    }
  }

  onBackwardClick(): void {
    this.bookingStepService.back();
  }

  onForwardClick(): void {
    this.bookingStepService.forward();
  }

  get forwardError(): string {
    return this._isValidForwardButton ? '' : this._errorMessage;
  }

  udpateOrderLinePartnerFormState(isValid: boolean, orderLineIndex: number): void {
    if (orderLineIndex === undefined) {
      return;
    }
    this._orderLinePartnerFormValidByIndex[orderLineIndex] = isValid;
    this.updateStateShowForwardButton(orderLineIndex);
  }

  updateStateShowForwardButton(orderLineIndex: number): void {
    if (orderLineIndex === undefined || this._orderLinePartnerFormValidByIndex.length < orderLineIndex) {
      return;
    }
    this._isValidForwardButton = !this._orderLinePartnerFormValidByIndex.some(value => value === false);
  }

  isPartnerRequired(orderLine: OrderLine): boolean {
    if (!orderLine || orderLine.productId == null) {
      return;
    }
    return this._valueRequiredPartnerFieldInAria(orderLine.productId, 'isPartnerRequired');
  }

  isBirthdayRequired(orderLine: OrderLine): boolean {
    if (!orderLine || orderLine.productId == null) {
      return;
    }
    return this._valueRequiredPartnerFieldInAria(orderLine.productId, 'isBirthdayRequired');
  }

  isShow(orderLine: OrderLine): boolean {
    return this.isPartnerRequired(orderLine) ||
      this.isBirthdayRequired(orderLine) ||
      this.isPhoneRequired(orderLine) ||
      this.isAddressRequired(orderLine) ||
      this.isEmailRequired(orderLine);
  }

  updateStartPersonNumbering(startNumbering: number): void {
    if (startNumbering === undefined) {
      return;
    }
    this.startPersonsNumbering = startNumbering;
  }

  isPhoneRequired(orderLine: OrderLine): boolean {
    if (!orderLine || orderLine.productId == null) {
      return false;
    }
    return this._valueRequiredPartnerFieldInAria(orderLine.productId, 'isPhoneRequired');
  }

  isAddressRequired(orderLine: OrderLine): boolean {
    if (!orderLine || orderLine.productId == null) {
      return false;
    }
    return this._valueRequiredPartnerFieldInAria(orderLine.productId, 'isAddressRequired');
  }

  isEmailRequired(orderLine: OrderLine): boolean {
    if (!orderLine || orderLine.productId == null) {
      return false;
    }
    return this._valueRequiredPartnerFieldInAria(orderLine.productId, 'isEmailRequired');
  }

  private _valueRequiredPartnerFieldInAria(productId: number, field: string): boolean {
    if (!productId || !this._areaItems || this._areaItems.length === 0 || !field) {
      return false;
    }
    return this._areaItems.some(item => (item.productId === productId) && item[field]);
  }
}
